var app = angular.module("leonardo");

var DocumentNoteDialog = function ($scope, $window, ngDialog, FolderFileService, AttachmentService) {
  $scope.note = $scope.ngDialogData.note;
  $scope.attachmentService = AttachmentService;

  angular.forEach($scope.note.attachments, function(attachment){
    if (attachment.document_file) {
      attachment.file = attachment.document_file.signed_view_url;
    }
    else if (attachment.link) {
      attachment.file = attachment.link;
    }
  });

  $scope.openAttachmentDialog = function (attachments, index) {
    if (attachments[index].document_file) {
      FolderFileService.getFileObjectAuthenticated(attachments[index].document_file, function (fileObject) {
        var array_url = (fileObject && fileObject.type) ? fileObject.type.split('/') : [];
        if (_.contains(array_url, 'image')) {
          ngDialog.open({
            template: 'views/templates/dialog/attachment/list.html',
            controller: 'AttachmentListDialog',
            className: 'ngdialog-theme-default ngdialog-attachments-view',
            data: {
              attachments: attachments,
              index: index
            }
          });
        }
        else {
          // Use signed_view_url for secure inline viewing
          $window.open(attachments[index].document_file.signed_view_url || attachments[index].document_file.secure_share_url);
        }
      });
    }
    else if (attachments[index].link) {
      $window.open(attachments[index].link);
    }
    else {
      FolderFileService.getFileObject(attachments[index].file, function (fileObject) {
        var array_url = (fileObject && fileObject.type) ? fileObject.type.split('/') : [];
        if (_.contains(array_url, 'image')) {
          ngDialog.open({
            template: 'views/templates/dialog/attachment/list.html',
            controller: 'AttachmentListDialog',
            className: 'ngdialog-theme-default ngdialog-attachments-view',
            data: {
              attachments: attachments,
              index: index
            }
          });
        }
        else {
          // Use signed_view_url for secure inline viewing
          $window.open(attachments[index].signed_view_url || attachments[index].secure_share_url || attachments[index].file);
        }
      });
    }
  };

};

app.controller('DocumentNoteDialog', ['$scope', '$window', 'ngDialog', 'FolderFileService', 'AttachmentService', DocumentNoteDialog]);
